<!-- Encabezado SUPERSOCIEDADES -->
<div *ngIf="tipoEntidad == 1 || tipoEntidadNombre == 'supersociedades'">
  <div class="historicos container my-5">
    <div class="row historicos__background py-3">
      <div class="col-12 col-md-6 mb-3 mb-xl-0">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.numero-proceso' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{ expedienteSupersociedadesDto?.numeroProceso || expedienteSupersociedadesDto?.radicado ?? '' }}
          </h3>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.fecha-creacion' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{
              (expedienteSupersociedadesDto?.fechaCreacion || expedienteSupersociedadesDto?.fechaCreacionExpediente)
                | date: 'dd/MM/yyyy'
            }}
          </h3>
        </div>
      </div>
    </div>
    <form class="mt-3">
      <div class="row mb-3">
        <div class="col-md-4 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label
              for="tipo_accion_supersociedades"
              class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.tipo-accion' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="tipo_accion_supersociedades"
              [value]="expedienteSupersociedadesDto?.tipo_accion || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-4 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label
              for="cuantia_supersociedades"
              class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.cuantia' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="cuantia_supersociedades"
              [value]="(expedienteSupersociedadesDto && expedienteSupersociedadesDto?.cuantia !== undefined && expedienteSupersociedadesDto?.cuantia !== null)
                       ? expedienteSupersociedadesDto.cuantia
                       : ('detalle-avance-procesal.no-especificado' | translate)"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-4">
          <div class="historicos__Card p-3">
            <label
              for="despacho_supersociedades"
              class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.despacho' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="despacho_supersociedades"
              [value]="expedienteSupersociedadesDto?.despacho || 'No especificado'"
              disabled></textarea>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt p-3">
            <label
              for="demandante_supersociedades"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.demandante' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="demandante_supersociedades"
              [value]="expedienteSupersociedadesDto?.nombre_demandante || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt p-3">
            <label
              for="abogado_demandante_supersociedades"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.abogado-demandante' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="abogado_demandante_supersociedades"
              [value]="expedienteSupersociedadesDto?.nombre_abogado_demandante || expedienteSupersociedadesDto?.abogado?.nombre || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--yellow p-3">
            <label
              for="demandado_supersociedades"
              class="historicos__Card--yellow__Title mb-2">
              {{ 'detalle-avance-procesal.demandado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="demandado_supersociedades"
              [value]="expedienteSupersociedadesDto?.nombre_demandado || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3">
          <div class="historicos__Card--yellow p-3">
            <label
              for="abogado_demandado_supersociedades"
              class="historicos__Card--yellow__Title mb-2">
              {{ 'detalle-avance-procesal.abogado-demandado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="abogado_demandado_supersociedades"
              [value]="expedienteSupersociedadesDto?.nombre_abogado_demandado || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- Encabezado SUPERSOCIEDADES, Procesos: Insolvencia-->
<div *ngIf="tipoEntidad == 1 || tipoEntidadNombre == 'ssi'">
  <div class="historicos container my-5">
    <div class="row historicos__background py-3">
      <div class="col-12 col-md-6 mb-3 mb-xl-0">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.numero-proceso' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{ expedienteInsolvenciaDto?.detalle?.numeroProceso ?? '' }}
          </h3>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.fecha-creacion' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{
            (expedienteInsolvenciaDto?.solicitud?.fechaRadicacion)
              | date: 'dd/MM/yyyy'
            }}
          </h3>
        </div>
      </div>
    </div>
    <form class="mt-3">
      <div class="row mb-3">
        <div class="col-md-4 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label
              for="tipo_accion_insolvencia"
              class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.tipo-accion' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="tipo_accion_insolvencia"
              [value]="expedienteInsolvenciaDto?.solicitud?.tipoAccion || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-4 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label
              for="estado_insolvencia"
              class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.estado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="estado_insolvencia"
              [value]="expedienteInsolvenciaDto?.solicitud?.estado || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-4">
          <div class="historicos__Card p-3">
            <label
              for="deudor_insolvencia"
              class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.deudor' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="deudor_insolvencia"
              [value]="expedienteInsolvenciaDto?.solicitud?.deudorSolicitante || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt p-3">
            <label
              for="demandante_insolvencia"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.demandante' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="demandante_insolvencia"
              [value]="expedienteInsolvenciaDto?.solicitud?.demandante || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt p-3">
            <label
              for="abogado_demandante_insolvencia"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.abogado-demandante' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="abogado_demandante_insolvencia"
              [value]="expedienteInsolvenciaDto?.solicitud?.abogado || expedienteSupersociedadesDto?.abogado?.nombre || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--yellow p-3">
            <label
              for="demandado_insolvencia"
              class="historicos__Card--yellow__Title mb-2">
              {{ 'detalle-avance-procesal.demandado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="demandado_insolvencia"
              [value]="expedienteInsolvenciaDto?.solicitud?.demandado || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- Encabezado SIC -->
<div *ngIf="tipoEntidad == 2 || tipoEntidadNombre == 'sic'">
  <div class="historicos container my-5">
    <div class="row historicos__background py-3">
      <div class="col-12 col-md-6 mb-3 mb-xl-0">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.numero-proceso' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{ expedienteSICDto.numero_proceso ?? '' }}
          </h3>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.fecha-creacion' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{ expedienteSICDto.fecha_creacion |  date: 'dd/MM/yyyy' : 'UTC' }}
          </h3>
        </div>
      </div>
    </div>
    <form class="mt-3">
      <div class="row mb-3">
        <div class="col-md-4 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label for="tipo_accion_SIC" class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.tipo-accion' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="tipo_accion_SIC"
              [value]="expedienteSICDto.tipo_accion || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-4 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label for="cuantia_SIC" class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.cuantia' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="cuantia_SIC"
              [value]="(expedienteSICDto && expedienteSICDto?.cuantia !== undefined && expedienteSICDto?.cuantia !== null)
                       ? expedienteSICDto.cuantia
                       : ('detalle-avance-procesal.no-especificado' | translate)"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-4">
          <div class="historicos__Card p-3">
            <label for="despacho_SIC" class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.despacho' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="despacho_SIC"
              [value]="expedienteSICDto.despacho || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt p-3">
            <label
              for="nombre_demandante_SIC"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.demandante' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="nombre_demandante_SIC"
              [value]="expedienteSICDto.nombre_demandante || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt p-3">
            <label
              for="abogado_demandante_SIC"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.abogado-demandante' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="abogado_demandante_SIC"
              [value]="expedienteSICDto.nombre_abogado_demandante || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--yellow p-3">
            <label
              for="demandado_SIC"
              class="historicos__Card--yellow__Title mb-2">
              {{ 'detalle-avance-procesal.demandado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="demandado_SIC"
              [value]="expedienteSICDto.nombre_demandado|| 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3">
          <div class="historicos__Card--yellow p-3">
            <label
              for="abogado_demandado_SIC"
              class="historicos__Card--yellow__Title mb-2">
              {{ 'detalle-avance-procesal.abogado-demandado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="abogado_demandado_SIC"
              [value]="expedienteSICDto.nombre_abogado_demandado || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- Encabezado SUPERSALUD -->
<div *ngIf="tipoEntidad == 3 || tipoEntidadNombre == 'supersalud'">
  <div class="historicos container my-5">
    <div class="row historicos__background py-3">
      <div class="col-12 col-md-6 mb-3 mb-xl-0">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.numero-proceso' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{ expedienteSupersaludDto.numero_proceso ?? '' }}
          </h3>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.fecha-creacion' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{ expedienteSupersaludDto.fecha_creacion |  date: 'dd/MM/yyyy' : 'UTC' }}
          </h3>
        </div>
      </div>
    </div>
    <form class="mt-3">
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="historicos__Card p-3">
            <label
              for="tipo_pretension_supersalud"
              class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.tipo-pretension' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="tipo_pretension_supersalud"
              [value]="expedienteSupersaludDto.tipo_pretension || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt p-3">
            <label
              for="nombre_demandante_supersalud"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.demandante' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="nombre_demandante_supersalud"
              [value]="expedienteSupersaludDto.nombre_demandante || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt p-3">
            <label
              for="abogado_demandante_supersalud"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.abogado-demandante' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="abogado_demandante_supersalud"
              [value]="expedienteSupersaludDto.nombre_abogado_demandante || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--yellow p-3">
            <label
              for="demandado_supersalud"
              class="historicos__Card--yellow__Title mb-2">
              {{ 'detalle-avance-procesal.demandado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="demandado_supersalud"
              [value]="expedienteSupersaludDto.nombre_demandado || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3">
          <div class="historicos__Card--yellow p-3">
            <label
              for="abogado_demandado_supersalud"
              class="historicos__Card--yellow__Title mb-2">
              {{ 'detalle-avance-procesal.abogado-demandado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="abogado_demandado_supersalud"
              [value]="expedienteSupersaludDto.nombre_abogado_demandado || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- Encabezado SUPERFINANCIERA -->
<div *ngIf="tipoEntidad == 4 || tipoEntidadNombre == 'superfinanciera'">
  <div class="historicos container my-5">
    <div class="row historicos__background py-3">
      <div class="col-12 col-md-6 mb-3 mb-xl-0">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.numero-proceso' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{ expedienteSuperfinancieraDto?.numero_proceso ?? '' }}
          </h3>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.fecha-creacion' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{
              expedienteSuperfinancieraDto?.fecha_creacion | date: 'dd/MM/yyyy' : 'UTC'
            }}
          </h3>
        </div>
      </div>
    </div>
    <form class="mt-3">
      <div class="row mb-3">
        <div class="col-md-4 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label
              for="tipo_accion_superfinanciera"
              class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.tipo-accion' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="tipo_accion_superfinanciera"
              [value]="expedienteSuperfinancieraDto?.tipo_accion || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-4 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label
              for="cuantia_superfinanciera"
              class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.cuantia' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="cuantia_superfinanciera"
              [value]="(expedienteSuperfinancieraDto && expedienteSuperfinancieraDto?.cuantia !== undefined && expedienteSuperfinancieraDto?.cuantia !== null)
                       ? expedienteSuperfinancieraDto.cuantia
                       : ('detalle-avance-procesal.no-especificado' | translate)"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-4">
          <div class="historicos__Card p-3">
            <label
              for="despacho_superfinanciera"
              class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.despacho' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="despacho_superfinanciera"
              [value]="expedienteSuperfinancieraDto?.despacho || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt p-3">
            <label
              for="nombre_demandante_superfinanciera"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.demandante' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="nombre_demandante_superfinanciera"
              [value]="expedienteSuperfinancieraDto?.nombre_demandante || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt p-3">
            <label
              for="abogado_demandante_superfinanciera"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.abogado-demandante' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="abogado_demandante_superfinanciera"
              [value]="expedienteSuperfinancieraDto?.nombre_abogado_demandante || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--yellow p-3">
            <label
              for="demandado_superfinanciera"
              class="historicos__Card--yellow__Title mb-2">
              {{ 'detalle-avance-procesal.demandado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="demandado_superfinanciera"
              [value]="expedienteSuperfinancieraDto?.nombre_demandado || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3">
          <div class="historicos__Card--yellow p-3">
            <label
              for="abogado_demandado_superfinanciera"
              class="historicos__Card--yellow__Title mb-2">
              {{ 'detalle-avance-procesal.abogado-demandado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="abogado_demandado_superfinanciera"
              [value]="expedienteSuperfinancieraDto?.nombre_abogado_demandado || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- Encabezado DNDA -->
<div *ngIf="tipoEntidad == 5 || tipoEntidadNombre == 'dnda'">
  <div class="historicos container my-5">
    <div class="row historicos__background py-3">
      <div class="col-12 col-md-6 mb-3 mb-xl-0">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.numero-proceso' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{ expedienteDndaDto?.numero_proceso ?? '' }}
          </h3>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.fecha-creacion' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{ expedienteDndaDto?.fecha_creacion | date: 'dd/MM/yyyy' : 'UTC' }}
          </h3>
        </div>
      </div>
    </div>
    <form class="mt-3">
      <div class="row mb-3">
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label for="tipo_proceso_DNDA" class="historicos__Card__Title mb-2">
              {{ 'gestion-expedientes-tabla.tipo-proceso' | translate }}
            </label>
            <textarea
              rows="2"
              id="tipo_proceso_DNDA"
              class="historicos__Card__Input text2-tipografia-govco"
              [value]="expedienteDndaDto?.tipo_tramite || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label for="ultima_actuacion" class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.ultima-actuacion' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="ultima_actuacion"
              [value]="expedienteDndaDto?.ultima_actuacion || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label for="cuantia_DNDA" class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.cuantia' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="cuantia_DNDA"
              [value]="expedienteDndaDto?.cuantia || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label for="despacho_DNDA" class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.despacho' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="despacho_DNDA"
              [value]="expedienteDndaDto?.despacho || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt p-3">
            <label
              for="nombre_demandante_DNDA"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.demandante' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="nombre_demandante_DNDA"
              [value]="expedienteDndaDto?.nombre_demandante || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt p-3">
            <label
              for="abogado_demandante_DNDA"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.abogado-demandante' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="abogado_demandante_DNDA"
              [value]="expedienteDndaDto?.nombre_abogado_demandante || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--yellow p-3">
            <label
              for="demandado_DNDA"
              class="historicos__Card--yellow__Title mb-2">
              {{ 'detalle-avance-procesal.demandado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="demandado_DNDA"
              [value]="expedienteDndaDto?.nombre_demandado || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3">
          <div class="historicos__Card--yellow p-3">
            <label
              for="abogado_demandado_DNDA"
              class="historicos__Card--yellow__Title mb-2">
              {{ 'detalle-avance-procesal.abogado-demandado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="abogado_demandado_DNDA"
              [value]="expedienteDndaDto?.nombre_abogado_demandado || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- Encabezado DIMAR -->
<div *ngIf="tipoEntidad == 6 || tipoEntidadNombre == 'dimar'">
  <div class="historicos container my-5">
    <div class="row historicos__background py-3">
      <div class="col-12 col-md-6 mb-3 mb-xl-0">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.numero-proceso' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{ expedienteDimarDto.numero_proceso ?? '' }}
          </h3>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.fecha-creacion' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{ expedienteDimarDto.fecha_creacion | date: 'dd/MM/yyyy' : 'UTC'}}
          </h3>
        </div>
      </div>
    </div>
    <form class="mt-3">
      <div class="row mb-3">
        <div class="col-md-6 mb-3 mb-xl-0 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label for="estado-proceso" class="historicos__Card__Title mb-2">
              {{ 'gestion-expedientes-tabla.estado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="estado-proceso"
              [value]="expedienteDimarDto.estado_proceso || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-6">
          <div class="historicos__Card p-3">
            <label for="capitania" class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.capitania' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="capitania"
              [value]="expedienteDimarDto.capitania_sedecentral || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4 mb-3 mb-xl-0 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt card-dimar p-3">
            <label for="cedula" class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.cedula' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="cedula"
              [value]="expedienteDimarDto.cedula || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-4 mb-3 mb-xl-0 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt card-dimar p-3">
            <label
              for="nombre_investigado"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.nombre-investigado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="nombre_investigado"
              [value]="expedienteDimarDto.nombre_investigado || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-4">
          <div class="historicos__Card--cobalt card-dimar p-3">
            <label
              for="tipo_siniestro"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.tipo-siniestro' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="tipo_siniestro"
              [value]="expedienteDimarDto.tipo_siniestro || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- Encabezado ICA -->
<div *ngIf="tipoEntidad == 7 || tipoEntidadNombre == 'ica'">
  <div class="historicos container my-5">
    <div class="row historicos__background py-3">
      <div class="col-12 col-md-6 mb-3 mb-xl-0">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.numero-proceso' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{ expedienteIcaDto?.numero_proceso ?? '' }}
          </h3>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.fecha-creacion' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{ expedienteIcaDto?.fecha_creacion | date: 'dd/MM/yyyy' : 'UTC' }}
          </h3>
        </div>
      </div>
    </div>
    <form class="mt-3">
      <div class="row mb-3">
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label for="tipo_accion_ICA" class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.tipo-accion' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="tipo_accion_ICA"
              [value]="expedienteIcaDto?.tipo_accion || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label for="cuantia_ICA" class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.variedad-vegetal' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="cuantia_ICA"
              [value]="expedienteIcaDto?.nombre_variedad_vegetal || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card p-3">
            <label for="tipo_especie_ICA" class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.tipo-especie' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="tipo_especie_ICA"
              [value]="expedienteIcaDto?.tipo_especie || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3">
          <div class="historicos__Card p-3">
            <label for="nombre_especie" class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.nombre-especie' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="nombre_especie"
              [value]="expedienteIcaDto?.nombre_especie || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt p-3">
            <label
              for="nombre_demandante_ICA"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.demandante' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="nombre_demandante_ICA"
              [value]="expedienteIcaDto?.nombre_demandante || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt p-3">
            <label
              for="nombre_abogado_demandante"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.abogado-demandante' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="nombre_abogado_demandante"
              [value]="expedienteIcaDto?.nombre_abogado_demandante || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3 mb-3 mb-xl-0">
          <div class="historicos__Card--yellow p-3">
            <label
              for="nombre_demandado"
              class="historicos__Card--yellow__Title mb-2">
              {{ 'detalle-avance-procesal.demandado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="nombre_demandado"
              [value]="expedienteIcaDto?.nombre_demandado || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-3">
          <div class="historicos__Card--yellow p-3">
            <label
              for="nombre_abogado_demandado"
              class="historicos__Card--yellow__Title mb-2">
              {{ 'detalle-avance-procesal.abogado-demandado' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="nombre_abogado_demandado"
              [value]="expedienteIcaDto?.nombre_abogado_demandado || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- Encabezado SUPERSOCIEDADES MERCANTILES -->
<div *ngIf="tipoEntidad == 1 || tipoEntidadNombre == 'ssm'">
  <div class="historicos container my-5">
    <div class="row historicos__background py-3">
      <div class="col-12 col-md-6 mb-3 mb-xl-0">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.numero-proceso' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{ expedienteSupersociedadesMercantilesDto?.radicado ?? '' }}
          </h3>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div
          class="d-flex flex-column align-items-center historicos__background__containers mx-1 py-2">
          <h6>{{ 'detalle-avance-procesal.fecha-creacion' | translate }}</h6>
          <h3 class="mb-0 color__cobalt">
            {{
              expedienteSupersociedadesMercantilesDto?.fechaCreacionExpediente
            }}
          </h3>
        </div>
      </div>
    </div>
    <form class="mt-3">
      <div class="row mb-3">

        <div class="col-md-6">
          <div class="historicos__Card p-3">
            <label for="delegatura" class="historicos__Card__Title mb-2">
              {{ 'detalle-avance-procesal.delegatura' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="delegatura"
              [value]="expedienteSupersociedadesMercantilesDto?.delegatura || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6 mb-3 mb-xl-0">
          <div class="historicos__Card--cobalt box p-3">
            <label
              for="tipo_proceso"
              class="historicos__Card--cobalt__Title mb-2">
              {{ 'gestion-expedientes-tabla.tipo-proceso' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="tipo_proceso"
              [value]="expedienteSupersociedadesMercantilesDto?.tipoProceso || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
        <div class="col-md-6">
          <div class="historicos__Card--cobalt box p-3">
            <label for="etapa" class="historicos__Card--cobalt__Title mb-2">
              {{ 'detalle-avance-procesal.etapa' | translate }}
            </label>
            <textarea
              rows="2"
              class="historicos__Card__Input text2-tipografia-govco"
              id="etapa"
              [value]="expedienteSupersociedadesMercantilesDto?.etapa || 'detalle-avance-procesal.no-especificado' | translate"
              disabled></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
